(() => {
  const css = '.grid-layout { margin-bottom: 24px !important; }';

  const apply = () => {
    const host = document.getElementById('tidio-chat');
    const root = host && host.shadowRoot;
    if (!root) return false;
    if (root.querySelector('style[data-bsb-tidio]')) return true;
    const style = document.createElement('style');
    style.setAttribute('data-bsb-tidio', '');
    style.textContent = css;
    root.appendChild(style);
    return true;
  };

  if (!apply()) document.addEventListener('tidioChat-ready', apply, { once: true });

  const watchChat = () => {
    const api = window.tidioChatApi;
    if (!api) return;
    api.on('open', () => document.documentElement.classList.add('bsb-chat-open'));
    api.on('close', () => document.documentElement.classList.remove('bsb-chat-open'));
  };

  if (window.tidioChatApi) {
    watchChat();
  } else {
    document.addEventListener('tidioChat-ready', watchChat, { once: true });
  }
})();
